import { AnimatePresence } from 'framer-motion';
import TimeTop from '../../components/time/timetop/TimeTop';
import DefaultLayout from '../../layouts/Default';
import { Outlet, useParams } from 'react-router-dom';
import TimeMonthList from '../../components/time/month/TimeMonthList';

function TimeMonthView() {
  const { date } = useParams() as {
    date: string;
  };

  return (
    <DefaultLayout>
      <TimeTop mode="month" />
      <AnimatePresence>
        {date ? <Outlet key={date} /> : <TimeMonthList />}
      </AnimatePresence>
    </DefaultLayout>
  );
}

export default TimeMonthView;
